// flight.ts

export interface Flight {
  id: number;
  origin: string;
  destination: string;
  flightType: string;
  departure: string; // keep as string (ISO / SQL datetime) for flexibility
  airline: string;
  price: string;
  isActive: boolean;
}

export const getFlights = async (): Promise<Flight[]> => {
  try {
    const res = await fetch("https://www.dreamstriphub.com/api/Flight_api.php");
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);

    const data = await res.json();

    return data.map((f: any) => ({
      id: parseInt(f.Id, 10),
      origin: f.Origin,
      destination: f.Destination,
      flightType: f.FlightType,
      departure: f.Departure, // you can wrap with new Date(f.Departure).toISOString() if needed
      airline: f.Airline,
      price: f.Price,
      isActive: f.IsActive === "1" || f.IsActive === 1,
    }));
  } catch (error) {
    console.error("Error fetching flights:", error);
    return [];
  }
};
